import BookShow from "components/shared/book/show";
import { Checkbox, Field } from "components/shared/form";
import { tableContainer } from "helpers/redux";
import React, { Fragment } from "react";
import { applyItem } from "sources/books/dictionaries";
import { getTrailerTypesWithFamily } from "sources/trailerTypes";
import DictionaryOption from "./option";

class ShowDictionary extends BookShow {
    state = {
        isLoading: true,
        current: {},
        displayName: "",
        isHidden: false,
        selected: null,
        trailerTypesWithFamily: [],
    };

    componentDidMount() {
        this.handleProps();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.shouldUpdate) {
            return this.props.getList();
        }
        if (nextProps.isLoadingList !== this.state.isLoading) {
            this.handleProps(nextProps);
        } else if (nextProps.location.pathname !== this.props.location.pathname) {
            this.handleProps(nextProps);
        }
    }

    handleProps = (nextProps) => {
        const { items, isLoadingList, match } = nextProps || this.props;
        const current = items.find((item) => item.id === parseInt(match.params.id));
        this.setState({
            isLoading: isLoadingList,
            current: current || {},
            displayName: "",
            isHidden: false,
            selected: null,
        });
        if (current?.propertyName === "TrailerType") {
            getTrailerTypesWithFamily().then((trailerTypesWithFamily) => this.setState({ trailerTypesWithFamily }));
        }
    };

    setValue = ({ value }) => {
        this.setState({ displayName: value });
    };

    setHiddenValue = ({ value }) => {
        this.setState({ isHidden: value });
    };

    changeSelected = (selected) => {
        this.setState({ selected });
    };

    createNewItem = (e) => {
        e.preventDefault();
        const { displayName, current, isHidden } = this.state;
        const { items, mergeParams } = this.props;
        if (displayName.length && !items.find((item) => item.displayName === displayName)) {
            const { type, entityType, id } = current;
            const params = {
                displayName,
                propertyName: displayName,
                catalogType: type,
                entityType,
                catalogId: id,
                ...(type === "NDSType" ? { isHidden } : {}),
            };
            return applyItem(params)
                .then(() => this.setState({ displayName: "", isHidden: false }))
                .then(() => mergeParams({}));
        }
    };

    renderHead = () => {
        const { displayName } = this.state.current;
        return (
            <div className="book-show__head">
                <div className="book-show__close close close--sm" onClick={this.props.back} />
                <div className="book-show__title">{displayName || ""}</div>
            </div>
        );
    };

    renderItem = (item) => {
        const { selected, current } = this.state;
        return (
            <DictionaryOption
                key={item.id}
                {...item}
                trailerTypesWithFamily={this.state.trailerTypesWithFamily}
                enums={this.props.enums}
                modal={this.props.modal}
                current={current}
                selected={selected}
                mergeParams={this.props.mergeParams}
                changeSelected={this.changeSelected}
            />
        );
    };

    renderBody = () => {
        const { current, displayName, isHidden } = this.state;
        const isNdsType = current.type === "NDSType" || current.propertyName === "NDSType";
        return (
            <Fragment>
                <form className="mb-4 card card-body" onSubmit={this.createNewItem}>
                    <Field
                        label="Название новой опции"
                        inputProps={{ name: "displayName" }}
                        onChange={this.setValue}
                        value={displayName}
                    />
                    {isNdsType && (
                        <Checkbox
                            label="Скрыть тип НДС"
                            fieldBeforeLabel
                            labelWrapper="col-auto col-form-label col-form-label-sm pl-0"
                            fieldWrapper="col-auto"
                            wrapper="panel__row"
                            bWrapper="row align-items-center"
                            inputProps={{ name: "isHidden" }}
                            onChange={this.setHiddenValue}
                            value={isHidden}
                        />
                    )}
                    <div className="d-flex justify-content-end">
                        <input className="btn btn-brand btn-sm" type="submit" value="Добавить" />
                    </div>
                </form>
                {current.items && current.items.length ? current.items.map(this.renderItem) : "Опций еще нет"}
            </Fragment>
        );
    };
}

export default tableContainer(ShowDictionary, "dictionaries");
